import { render, staticRenderFns } from "./pp-imp.vue?vue&type=template&id=60862be2&lang=html&"
import script from "./pp-imp.vue?vue&type=script&lang=js&"
export * from "./pp-imp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports